import { render, staticRenderFns } from "./MarketingCampaignDetailsIndex.vue?vue&type=template&id=20cad56d&scoped=true"
import script from "./MarketingCampaignDetailsIndex.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignDetailsIndex.vue?vue&type=script&lang=js"
import style0 from "./MarketingCampaignDetailsIndex.vue?vue&type=style&index=0&id=20cad56d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cad56d",
  null
  
)

export default component.exports